/**
 * @generated SignedSource<<44f1b2a07c170d60a37f6dd1ecac385e>>
 * @relayHash 601fa9b0f856e380cdfbd3eb023e7380
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/442.0.0-2023-12-07T14:56:12.870Z/MessageBannerQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerQuery$variables = {
  hasPreviewVariables: boolean;
  hasRegisteredUserMessages: boolean;
  hasTradeUserId: boolean;
  hasUnregisteredUserMessages: boolean;
  isFirstTimeVisitor: boolean;
  previewSetId: string;
  previewUserType: string;
  userId: string;
};
export type MessageBannerQuery$data = {
  readonly viewer: {
    readonly activePromotion: {
      readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_activePromotion">;
    } | null;
    readonly expiringPromotion: {
      readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_expiringPromotion">;
    } | null;
    readonly previewMessages?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_messages" | "sharedMessageHelpers_messages">;
    } | null> | null;
    readonly unregisteredUserMessages?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_messages" | "sharedMessageHelpers_messages">;
    } | null> | null;
    readonly user?: {
      readonly profile?: {
        readonly " $fragmentSpreads": FragmentRefs<"TradeEOYMessaging_profile">;
      } | null;
      readonly registeredUserMessages: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_messages" | "sharedMessageHelpers_messages">;
      } | null> | null;
      readonly tradeFirmRewards?: {
        readonly " $fragmentSpreads": FragmentRefs<"TradeEOYMessaging_tradeFirmRewards">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_viewer" | "TradeEOYMessaging_viewer">;
  };
};
export type MessageBannerQuery = {
  response: MessageBannerQuery$data;
  variables: MessageBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasPreviewVariables"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasRegisteredUserMessages"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUnregisteredUserMessages"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFirstTimeVisitor"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "previewSetId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "previewUserType"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v8 = {
  "alias": "tradeEOY2020",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "tradeEOY2020FF"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"tradeEOY2020FF\")"
},
v9 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PromotionMeta",
  "kind": "LinkedField",
  "name": "promotionMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "desktopBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "desktopBannerCta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileBannerMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileBannerCta",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PromotionMeta",
  "kind": "LinkedField",
  "name": "promotionMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urgencyMessagingDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urgencyMessagingDaysBeforeExpiration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages"
  },
  {
    "kind": "InlineDataFragmentSpread",
    "name": "sharedMessageHelpers_messages",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageSetItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingMessage",
                "kind": "LinkedField",
                "name": "anchors",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentYearPoints",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v21 = [
  {
    "kind": "Variable",
    "name": "isFirstTimeVisitor",
    "variableName": "isFirstTimeVisitor"
  }
],
v22 = [
  {
    "kind": "Variable",
    "name": "setId",
    "variableName": "previewSetId"
  },
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "previewUserType"
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "FlatAdjustmentRate",
  "kind": "LinkedField",
  "name": "flatAdjustmentRate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            (v17/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "kind": "LinkedField",
      "name": "cta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MessageSetItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "impressionCap",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingMessage",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "kind": "LinkedField",
            "name": "anchors",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v25/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageBannerCarousel_viewer"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "TradeEOYMessaging_viewer",
            "selections": [
              (v8/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "sharedMessageHelpers_activePromotion",
                "selections": [
                  (v10/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "expiringPromotion",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "sharedMessageHelpers_expiringPromotion",
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "expiringPromoMessageHelpers_expiringPromotion",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasRegisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MessageBannerCarousel_user"
                  },
                  {
                    "alias": "registeredUserMessages",
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "kind": "LinkedField",
                    "name": "bannerMessages",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "condition": "hasTradeUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "TradeEOYMessaging_profile",
                            "selections": (v18/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "TradeEOYMessaging_tradeFirmRewards",
                            "selections": [
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasUnregisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "unregisteredUserMessages",
                "args": (v21/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasPreviewVariables",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "previewMessages",
                "args": (v22/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "MessageBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "promoCodeMessaging",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "promoCodeMessaging"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buyerDisplayable",
                "storageKey": null
              },
              (v24/*: any*/),
              (v20/*: any*/),
              (v10/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "expiringPromotion",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PercentAdjustmentRate",
                "kind": "LinkedField",
                "name": "percentAdjustmentRate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate",
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "condition": "hasRegisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "registeredUserMessages",
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "kind": "LinkedField",
                    "name": "bannerMessages",
                    "plural": true,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  },
                  {
                    "condition": "hasTradeUserId",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "kind": "LinkedField",
                            "name": "currentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "kind": "LinkedField",
                                "name": "programInfo",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasUnregisteredUserMessages",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "unregisteredUserMessages",
                "args": (v21/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v26/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasPreviewVariables",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "previewMessages",
                "args": (v22/*: any*/),
                "concreteType": "MessageSetModule",
                "kind": "LinkedField",
                "name": "messageSet",
                "plural": true,
                "selections": (v26/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/442.0.0-2023-12-07T14:56:12.870Z/MessageBannerQuery",
    "metadata": {},
    "name": "MessageBannerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c63f4234f44c70122d5d6ad92127a4d2";

export default node;
